import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from "@mui/material";
import {
  Dashboard,
  People,
  Route,
  Storefront,
  Inventory,
  LocalShipping,
} from "@mui/icons-material";

function Sidebar() {
  return (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#1e1e2f",
        color: "#fff",

        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 2,
      }}
    >
      {/* Sidebar Header */}
      <Box>
        <Typography variant="h6" gutterBottom sx={{ textAlign: "center" }}>
          Admin Dashboard
        </Typography>
        <Divider sx={{ backgroundColor: "#52525b" }} />
        {/* Navigation List */}
        <List>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/">
              <ListItemIcon>
                <Dashboard sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/drivers">
              <ListItemIcon>
                <People sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Driver Management" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/routes">
              <ListItemIcon>
                <Route sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Route Management" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/shops">
              <ListItemIcon>
                <Storefront sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Shop Management" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/product">
              <ListItemIcon>
                <Inventory sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Products Management" />
            </ListItemButton>
          </ListItem>
          {/* <ListItem disablePadding>
            <ListItemButton component={Link} to="/delivery">
              <ListItemIcon>
                <LocalShipping sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Delivery Management" />
            </ListItemButton>
          </ListItem> */}
          {/* <ListItem disablePadding>
            <ListItemButton component={Link} to="/invoice">
              <ListItemIcon>
                <LocalShipping sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Invoice Management" />
            </ListItemButton>
          </ListItem> */}
          {/* <ListItem disablePadding>
            <ListItemButton component={Link} to="/deliveryForm">
              <ListItemIcon>
                <LocalShipping sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Invoice Management" />
            </ListItemButton>
          </ListItem> */}
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/Form">
              <ListItemIcon>
                <LocalShipping sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Delivery Management" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/admin">
              <ListItemIcon>
                <LocalShipping sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Admin Users" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>

      {/* Sidebar Footer */}
      <Divider sx={{ backgroundColor: "#52525b", marginBottom: 2 }} />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body2" color="gray">
          © 2024 Admin Panel
        </Typography>
      </Box>
    </Box>
  );
}

export default Sidebar;
